"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ownerTgBotInviteNotificationUsersList = exports.ownerTgBotInviteNotificationShortStatistics = exports.ownerTgBotInviteNotificationSelectedUsersIds = exports.ownerTgBotInviteNotificationSelectedUsers = exports.ownerTgBotInviteNotificationFullStatistics = exports.ownerTgBotInviteNotificationFilters = exports.inviteToHoaNotificationFilters = exports.inviteToHoaNotificationFullStatistics = exports.inviteToHoaNotificationShortStatistics = exports.massHoaNotificationFilters = exports.massHoaNotificationFullStatistics = exports.massHoaNotificationShortStatistics = exports.registryCheckErrors = exports.registryTgBotInviteStatistics = exports.townSettings = exports.registryFilters = exports.registryHistory = exports.massHoaNotificationSelectedUsersIds = exports.massHoaNotificationSelectedUsers = exports.massHoaNotificationUsersList = exports.inviteToHoaNotificationSelectedUsersIds = exports.inviteToHoaNotificationSelectedUsers = exports.inviteToHoaNotificationUsersList = void 0;
var inviteToHoaNotificationUsersList_1 = require("./inviteToHoaNotificationUsersList");
Object.defineProperty(exports, "inviteToHoaNotificationUsersList", {
  enumerable: true,
  get: function () {
    return __importDefault(inviteToHoaNotificationUsersList_1).default;
  }
});
var inviteToHoaNotificationSelectedUsers_1 = require("./inviteToHoaNotificationSelectedUsers");
Object.defineProperty(exports, "inviteToHoaNotificationSelectedUsers", {
  enumerable: true,
  get: function () {
    return __importDefault(inviteToHoaNotificationSelectedUsers_1).default;
  }
});
var inviteToHoaNotificationSelectedUsersIds_1 = require("./inviteToHoaNotificationSelectedUsersIds");
Object.defineProperty(exports, "inviteToHoaNotificationSelectedUsersIds", {
  enumerable: true,
  get: function () {
    return __importDefault(inviteToHoaNotificationSelectedUsersIds_1).default;
  }
});
var massHoaNotificationUsersList_1 = require("./massHoaNotificationUsersList");
Object.defineProperty(exports, "massHoaNotificationUsersList", {
  enumerable: true,
  get: function () {
    return __importDefault(massHoaNotificationUsersList_1).default;
  }
});
var massHoaNotificationSelectedUsers_1 = require("./massHoaNotificationSelectedUsers");
Object.defineProperty(exports, "massHoaNotificationSelectedUsers", {
  enumerable: true,
  get: function () {
    return __importDefault(massHoaNotificationSelectedUsers_1).default;
  }
});
var massHoaNotificationSelectedUsersIds_1 = require("./massHoaNotificationSelectedUsersIds");
Object.defineProperty(exports, "massHoaNotificationSelectedUsersIds", {
  enumerable: true,
  get: function () {
    return __importDefault(massHoaNotificationSelectedUsersIds_1).default;
  }
});
var registryHistory_1 = require("./registryHistory");
Object.defineProperty(exports, "registryHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(registryHistory_1).default;
  }
});
var registryFilters_1 = require("./registryFilters");
Object.defineProperty(exports, "registryFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(registryFilters_1).default;
  }
});
var townSettings_1 = require("./townSettings");
Object.defineProperty(exports, "townSettings", {
  enumerable: true,
  get: function () {
    return __importDefault(townSettings_1).default;
  }
});
var registryTgBotInviteStatistics_1 = require("./registryTgBotInviteStatistics");
Object.defineProperty(exports, "registryTgBotInviteStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(registryTgBotInviteStatistics_1).default;
  }
});
var registryErrors_1 = require("./registryErrors");
Object.defineProperty(exports, "registryCheckErrors", {
  enumerable: true,
  get: function () {
    return __importDefault(registryErrors_1).default;
  }
});
var massHoaNotificationShortStatistics_1 = require("./massHoaNotificationShortStatistics");
Object.defineProperty(exports, "massHoaNotificationShortStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(massHoaNotificationShortStatistics_1).default;
  }
});
var massHoaNotificationFullStatistics_1 = require("./massHoaNotificationFullStatistics");
Object.defineProperty(exports, "massHoaNotificationFullStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(massHoaNotificationFullStatistics_1).default;
  }
});
var massHoaNotificationFilters_1 = require("./massHoaNotificationFilters");
Object.defineProperty(exports, "massHoaNotificationFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(massHoaNotificationFilters_1).default;
  }
});
var inviteToHoaNotificationShortStatistics_1 = require("./inviteToHoaNotificationShortStatistics");
Object.defineProperty(exports, "inviteToHoaNotificationShortStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(inviteToHoaNotificationShortStatistics_1).default;
  }
});
var inviteToHoaNotificationFullStatistics_1 = require("./inviteToHoaNotificationFullStatistics");
Object.defineProperty(exports, "inviteToHoaNotificationFullStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(inviteToHoaNotificationFullStatistics_1).default;
  }
});
var inviteToHoaNotificationFilters_1 = require("./inviteToHoaNotificationFilters");
Object.defineProperty(exports, "inviteToHoaNotificationFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(inviteToHoaNotificationFilters_1).default;
  }
});
var ownerTgBotInviteNotificationFilters_1 = require("./ownerTgBotInviteNotificationFilters");
Object.defineProperty(exports, "ownerTgBotInviteNotificationFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(ownerTgBotInviteNotificationFilters_1).default;
  }
});
var ownerTgBotInviteNotificationFullStatistics_1 = require("./ownerTgBotInviteNotificationFullStatistics");
Object.defineProperty(exports, "ownerTgBotInviteNotificationFullStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(ownerTgBotInviteNotificationFullStatistics_1).default;
  }
});
var ownerTgBotInviteNotificationSelectedUsers_1 = require("./ownerTgBotInviteNotificationSelectedUsers");
Object.defineProperty(exports, "ownerTgBotInviteNotificationSelectedUsers", {
  enumerable: true,
  get: function () {
    return __importDefault(ownerTgBotInviteNotificationSelectedUsers_1).default;
  }
});
var ownerTgBotInviteNotificationSelectedUsersIds_1 = require("./ownerTgBotInviteNotificationSelectedUsersIds");
Object.defineProperty(exports, "ownerTgBotInviteNotificationSelectedUsersIds", {
  enumerable: true,
  get: function () {
    return __importDefault(ownerTgBotInviteNotificationSelectedUsersIds_1).default;
  }
});
var ownerTgBotInviteNotificationShortStatistics_1 = require("./ownerTgBotInviteNotificationShortStatistics");
Object.defineProperty(exports, "ownerTgBotInviteNotificationShortStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(ownerTgBotInviteNotificationShortStatistics_1).default;
  }
});
var ownerTgBotInviteNotificationUsersList_1 = require("./ownerTgBotInviteNotificationUsersList");
Object.defineProperty(exports, "ownerTgBotInviteNotificationUsersList", {
  enumerable: true,
  get: function () {
    return __importDefault(ownerTgBotInviteNotificationUsersList_1).default;
  }
});